import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { AuthModalComponent } from '@app/core/user/containers/auth-modal/auth-modal.component';
import * as reducers from '@app/core/user/store/reducers';
import { IAppState } from '@app/store';
import { select, Store } from '@ngrx/store';
import { UserService } from '@app/core/user/services/user/user.service';
import { AuthModal } from '@app/shared/model/interfaces/AuthDialog/AuthModal';
import { Credentials } from '@vestiaire/api-sdk-angular';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'vc-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit, OnDestroy {
  @Input()
  popinForced: boolean;
  @Input()
  promoOffer: string;
  @Input()
  credentialFirstname: string;
  @Output()
  registerFirstStep = new EventEmitter<boolean>();

  public credentials: Credentials;
  public blocToShow: BehaviorSubject<'email-register' | 'validation-register'> = new BehaviorSubject<
    'email-register' | 'validation-register'
  >('email-register');
  public email: FormControl;
  public firstname: string;

  constructor(
    private dialogRef: MatDialogRef<AuthModalComponent>,
    private store: Store<IAppState>,
    private userService: UserService
  ) {}

  ngOnInit() {
    this.store.pipe(select(reducers.isAuthenticated)).subscribe(
      res => {
        if (res) {
          this.dialogRef.close();
        }
      },
      err => {
        // Silent catch error because we don't have anything to do
      }
    );

    this.userService.getAuthDialogData().subscribe(
      res => {
        if (res && res.credentials && res.credentials.email) {
          this.blocToShow.next('validation-register');
          this.registerFirstStep.emit(false);
          this.credentials = res.credentials;
          this.firstname = res.firstname;
        }
      },
      err => {}
    );
  }

  ngOnDestroy() {
    this.userService.setAuthDialogData(null);
  }

  public setUser(data: { credentials: Credentials; firstname?: string }) {
    this.blocToShow.next('validation-register');
    this.registerFirstStep.emit(false);
    this.credentials = data.credentials;
    this.firstname = data.firstname;

    this.userService.setAuthDialogData({
      authModalType: 'register',
      credentials: this.credentials,
      firstname: this.firstname
    } as AuthModal);
  }
}
